import { colorKeywordToRGB, rgbBackgroundToTextColor } from "../../../Utils/Functions/helpers";
import styles from "./SRFButton.module.css"


const SRFButton = ({ color = "rgb(32, 52, 106)", type, children, width, ...rest }) => (
  <button
    style={{ "--color": color, "--text-color": rgbBackgroundToTextColor(colorKeywordToRGB(color)), width }}
    className={styles.SRFButton}
    type={type ? type : "button"}
    {...rest}
  >
    {children}
  </button>
);

export default SRFButton;
